import { useEffect } from 'react';
import { useUIStore } from './useUIStore';

export const ThemeSync = () => {
  const theme = useUIStore((s) => s.theme);

  useEffect(() => {
    const root = window.document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [theme]);

  return null;
};